/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionListItemDto
 */
export interface QuestionListItemDto {
    /**
     * Question unique identifier
     * @type {string}
     * @memberof QuestionListItemDto
     */
    id?: string;
    /**
     * Question key/code
     * @type {string}
     * @memberof QuestionListItemDto
     */
    key?: string;
    /**
     * Question label/text
     * @type {string}
     * @memberof QuestionListItemDto
     */
    label?: string;
    /**
     * Question type code
     * @type {string}
     * @memberof QuestionListItemDto
     */
    questionTypeCode?: string;
    /**
     * Question type label
     * @type {string}
     * @memberof QuestionListItemDto
     */
    questionTypeLabel?: string;
    /**
     * Step number in the questionnaire
     * @type {number}
     * @memberof QuestionListItemDto
     */
    step?: number | null;
    /**
     * Display order of the question
     * @type {number}
     * @memberof QuestionListItemDto
     */
    displayOrder?: number;
    /**
     * Icon key for the question
     * @type {string}
     * @memberof QuestionListItemDto
     */
    iconKey?: string | null;
    /**
     * Group title for question grouping
     * @type {string}
     * @memberof QuestionListItemDto
     */
    groupTitle?: string | null;
    /**
     * Whether the question is required
     * @type {boolean}
     * @memberof QuestionListItemDto
     */
    isRequired?: boolean;
    /**
     * Number of possible answers
     * @type {number}
     * @memberof QuestionListItemDto
     */
    possibleAnswersCount?: number;
}

/**
 * Check if a given object implements the QuestionListItemDto interface.
 */
export function instanceOfQuestionListItemDto(value: object): value is QuestionListItemDto {
    return true;
}

export function QuestionListItemDtoFromJSON(json: any): QuestionListItemDto {
    return QuestionListItemDtoFromJSONTyped(json, false);
}

export function QuestionListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'key': json['key'] == null ? undefined : json['key'],
        'label': json['label'] == null ? undefined : json['label'],
        'questionTypeCode': json['questionTypeCode'] == null ? undefined : json['questionTypeCode'],
        'questionTypeLabel': json['questionTypeLabel'] == null ? undefined : json['questionTypeLabel'],
        'step': json['step'] == null ? undefined : json['step'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'groupTitle': json['groupTitle'] == null ? undefined : json['groupTitle'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'possibleAnswersCount': json['possibleAnswersCount'] == null ? undefined : json['possibleAnswersCount'],
    };
}

export function QuestionListItemDtoToJSON(json: any): QuestionListItemDto {
    return QuestionListItemDtoToJSONTyped(json, false);
}

export function QuestionListItemDtoToJSONTyped(value?: QuestionListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'key': value['key'],
        'label': value['label'],
        'questionTypeCode': value['questionTypeCode'],
        'questionTypeLabel': value['questionTypeLabel'],
        'step': value['step'],
        'displayOrder': value['displayOrder'],
        'iconKey': value['iconKey'],
        'groupTitle': value['groupTitle'],
        'isRequired': value['isRequired'],
        'possibleAnswersCount': value['possibleAnswersCount'],
    };
}

